const router = [
  {
    path: "/login",
    name: "login",
    module: "Login",
    meta: {
      analyticsIgnore: true,
    },
    component: () => import("./pages/Login"),
    beforeEnter: (to, from, next) => {
      if (to.query.path) {
        next();
      } else {
        next({
          name: "instansi.pilih",
        });
      }
    },
  },
  {
    path: "/403",
    name: "no-akses",
    module: "Akses Tidak Tersedia",
    meta: {
      auth: false,
      module: "Akses Tidak Tersedia",
    },
    component: () => import("./pages/NoAccess.vue"),
  },
  {
    path: "/kelola/instansi/:instansi_id/peserta-kelas",
    name: "peserta-kelas",
    module: "Peserta Kelas",
    meta: {
      auth: true,
      module: "Peserta Kelas",
    },
    component: () => import("./pages/List.vue"),
  },
  {
    path: "/kelola/instansi/:instansi_id/pengelola-kelas",
    name: "pengelola-kelas",
    module: "Pengelola Kelas",
    meta: {
      auth: true,
      module: "Pengelola Kelas",
    },
    component: () => import("./pages/ListPengelola.vue"),
  },
  {
    path: "/pencarian",
    name: "user.search",
    meta: {
      module: "Pencarian User",
      auth: true,
    },
    component: () => import("./pages/Pencarian.vue"),
  },
  {
    path: "/pppk/riwayatpeserta",
    name: "user.search.pppk",
    meta: {
      module: "Pencarian Kelas Peserta PPPK",
      auth: true,
    },
    component: () => import("./pages/PencarianPPPK.vue"),
  },
  {
      path: "/berkas",
      name: "user.berkas",
      meta: {
        module: "Pemberkasan",
        auth: true,
      },
      component: () => import("./pages/Berkas.vue"),
    },
];

export default router;
